import ScrollReveal from "@/components/motion/ScrollReveal";
import { ENVIRONMENT_PROOF } from "@/data/environment";

const PUZZLE_PIECES = [
    "col-span-2 row-span-2 puzzle-piece",
    "col-span-2 row-span-1 puzzle-piece",
    "col-span-1 row-span-2 puzzle-piece",
    "col-span-1 row-span-1 puzzle-piece",
    "col-span-2 row-span-1 puzzle-piece",
    "col-span-1 row-span-1 puzzle-piece",
];

export default function EnvironmentProofPuzzle() {
    return (
        <div className="environment-puzzle grid grid-cols-4 auto-rows-[minmax(100px,1fr)] sm:auto-rows-[minmax(130px,1fr)] md:auto-rows-[minmax(160px,1fr)] gap-[3px] rounded-2xl overflow-hidden bg-zinc-800/80 p-[3px]">
            {ENVIRONMENT_PROOF.map((photo, index) => (
                <ScrollReveal
                    key={photo.src}
                    delay={index * 0.04}
                    variant="scaleIn"
                    className={`${PUZZLE_PIECES[index] ?? "col-span-1 row-span-1 puzzle-piece"} min-h-[100px]`}
                >
                    <figure className="group relative h-full w-full overflow-hidden bg-zinc-900">
                        <img
                            src={photo.src}
                            alt={photo.caption}
                            className="motion-img h-full w-full object-cover"
                            loading="lazy"
                        />
                        <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent px-3 py-2.5 sm:px-4 sm:py-3">
                            <p className="text-xs sm:text-sm text-white/90 leading-snug">
                                {photo.caption}
                            </p>
                        </figcaption>
                    </figure>
                </ScrollReveal>
            ))}
        </div>
    );
}

